/*SYSTEM IMPORTS*/
    import React from 'react'
    import c from 'classnames'

const Burger = props => (
    <div className={c( "burger", props.className )} onClick={ props.onClick }>
        <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div className="cross">
            <span></span>
            <span></span>
        </div>
    </div>
)

export default Burger